export default __webpack_public_path__ + "static/media/10-hurts.4bab4418.png";